enum InventoryPermission {
  Prem_Inventory_Create = 'Prem_Inventory_Create',
  Prem_Inventory_View = 'Prem_Inventory_View',
  Prem_Inventory_Update = 'Prem_Inventory_Update',
  Prem_Inventory_Delete = 'Prem_Inventory_Delete',
  Prem_Inventory_Manage = 'Prem_Inventory_Manage',
}

export default InventoryPermission;
